import Icon from 'veui/components/Icon'

Icon.register({
  'data-folder-search': {
    paths: [
      {
        fill: '#298ef2',
        opacity: '.1',
        d: 'M28 26c0 1.47-5.67 2.67-12.67 2.67S2.67 27.47 2.67 26s5.67-2.67 12.66-2.67S28 24.53 28 26z'
      },
      {
        fill: '#e8f3ff',
        stroke: '#b3cfee',
        'stroke-width': '.67',
        d: 'M20.67 5.1h-8.64l-.07-.23c-.2-.7-.85-1.2-1.6-1.2h-3c-.77 0-1.44.53-1.62 1.27l-.04.18-.19.06c-.7.21-1.18.86-1.18 1.6v3.89A3.67 3.67 0 008 14.33h10.67a3.67 3.67 0 003.66-3.66v-3.9c0-.91-.74-1.66-1.66-1.66z'
      },
      {
        fill: '#fff',
        stroke: '#b3cfee',
        'stroke-width': '.67',
        d: 'M4.67 7h-.13c-.91.07-1.6.87-1.53 1.8l1.14 15.32c.06.87.79 1.55 1.66 1.55h19.32c.87 0 1.6-.68 1.66-1.55L27.93 8.8v-.12c0-.92-.74-1.67-1.66-1.67H4.67z'
      },
      {
        fill: '#fff',
        stroke: '#b3cfee',
        'stroke-width': '.67',
        d: 'M9.96 19.45a1.09 1.09 0 101.42 1.64l3.38-2.93a1.09 1.09 0 10-1.43-1.64l-3.37 2.93z'
      },
      {
        fill: '#e8f3ff',
        stroke: '#b3cfee',
        'stroke-width': '.67',
        d: 'M21.32 16.72c-.4 2.53-2.8 4.25-5.36 3.85s-4.3-2.79-3.9-5.32c.4-2.53 2.8-4.25 5.36-3.85s4.3 2.79 3.9 5.32z'
      }
    ],
    width: '32',
    height: '32'
  }
})
